import React from 'react';
import PropTypes from 'prop-types';
import Card from 'kepler/lib/components/Card';
import { Checkbox } from '@paypalcorp/pp-react';
import { extend } from 'lodash';

class MultiSelectionCard extends React.Component {
  onChange = () => {
    let { handleChange, step } = this.props;
    handleChange(step.value);
  };

  handleStyles = checkboxName => {
    let marginStyle = { marginTop: '0px' };
    if (
      checkboxName === 'marketplace' ||
      checkboxName === 'invoiceOrEstimate'
    ) {
      extend(marginStyle, { marginTop: '-26px' });
    }
    return marginStyle;
  };

  render() {
    let { step, isActive } = this.props,
      marginStyle = this.handleStyles(step.value);
    return (
      <Card className={`step-container ${isActive ? 'step-active' : ''}`}>
        <Checkbox
          id={`checkbox-${step.value}`}
          name={`checkbox-${step.value}`}
          onClick={this.onChange}
          onKeyDown={e => e.keyCode === 13 && this.onChange()}
          checked={isActive}
          label={
            <div className={`step-container-content ${step.value}`}>
              <img
                style={marginStyle}
                className="step-container-content-image"
                src={step.icon}
                alt=""
                role="presentation"
              />
              <p className="step-container-content-title">{step.title}</p>
            </div>
          }
        />
      </Card>
    );
  }
}

MultiSelectionCard.propTypes = {
  step: PropTypes.object,
  handleChange: PropTypes.func,
  isActive: PropTypes.bool
};

export default MultiSelectionCard;
